import React from "react";
import { Grid, withStyles } from "@material-ui/core";
import { Slider } from "@material-ui/lab";
import ProgressStepper from "./ProgressStepper";

const styles = (theme) => ({  
  sliderContainer: {
    padding: 20,
  },
  root: {
    position: "relative",
  },
  title: {
    color: theme.dispatchPanelHeaderColor,
    marginTop: 4,
  },
  slider: {
    padding: "20px 0px",
  },
  label: {
    position: "absolute",
    padding: "0.15rem 0.25rem",
    color: theme.TextColor,
    backgroundColor: theme.tooltipBGColor,
    borderRadius: 2,
    display: "flex",
    justifyContent: "center",
    marginLeft: -14,
    minWidth: 20,
    filter: `drop-shadow(0px 0px 1px ${theme.shadowColor})`,
    "&::after": {
      content: '""',
      position: "absolute",
      left: "16%",
      top: "80%",
      borderWidth: 10,
      borderStyle: "solid",
      borderColor: `${theme.tooltipBGColor} transparent transparent transparent`,
    },
  },
  track: {
    height: 5,
    borderRadius: 5,
  },
  trackBefore: {
    borderRadius: 5,
  },
  thumb: {
    width: 20,
    height: 20,
    "&$activated": {
      boxShadow: `0px 0px 0px 8px ${theme.primaryBoxShadow}`,
    },
  },
  activated: {},
  timeLabels: {
    display: "flex",
    justifyContent: "space-between",
  },
});

const RMAX_Slider = ({ title, value, min, max, step, classes, ...otherProps }) => {
  return (
    <Grid item xs={6} className={classes.sliderContainer}>
      <Grid className={classes.title} item xs={12}>
        <span>{title}</span>
      </Grid>
      <div className={classes.root}>
        <div
          className={classes.label}
          style={{ left: `${(value * 100) / max}%` }}
        >
          {value}
        </div>
        <ProgressStepper steps={max / step + 1} currentStep={value / step} />
        <Slider
          classes={{
            container: classes.slider,
            track: classes.track,
            trackBefore: classes.trackBefore,
            activated: classes.activated,
            thumb: classes.thumb,
          }}
          value={value}
          min={min}
          max={max}
          step={step}
          {...otherProps}
        />
        <div className={classes.timeLabels}>
          <span>{min}</span>
          <span>{max}</span>
        </div>
      </div>
    </Grid>
  );
};

export default withStyles(styles)(RMAX_Slider);
